export enum ServiceChecklistActionType {
  FETCH_SERVICE_CHECKLIST = "FETCH_SERVICE_CHECKLIST",
  FETCH_SERVICE_CHECKLIST_SUCCESS = "FETCH_SERVICE_CHECKLIST_SUCCESS",
  SET_SERVICE_CHECKLIST = "SET_SERVICE_CHECKLIST",
}
